let language = {
    DETAIL_SPECIFICATION_IMAGE: "specification Image",
    DETAIL_SEE_DETAILS: "[see details]",
    
}

export { language }